<template>
  <el-header class="main-header">
    <router-link class="main-header__left" to="/">
      <img src="@/assets/images/ols-logo.png" class="mr-16" />
      <span class="font-20 font-w-bold">Open Platform</span>
    </router-link>
    <nav class="main-header__nav">
      <ul>
        <li
          v-for="menu in menus"
          :key="menu.name">
          <router-link
            :to="{ path: menu.path }">
            {{ menu.name }}
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="main-header__lang">
      <el-dropdown class="font-w-semi-bold font-14">
        <span class="el-dropdown-link flex-container align-center">
          <img :src="isFlag" height="14" style="border:1px solid #f4f4f4;" />
          <span class="ml-6">{{ switchLang }}</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="handleSwitchLanguage('id')">
              <img src="/img/icons/id.svg" height="14" />
              <span class="ml-6">Indonesia</span>
            </el-dropdown-item>
            <el-dropdown-item @click="handleSwitchLanguage('en')">
              <img src="/img/icons/en.svg" height="14" />
              <span class="ml-6">English</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <div class="main-header__right">
      <div v-if="!isLoginOpenApi">
        <router-link to="/login">
          <el-button>{{ $t('navbar.login') }}</el-button>
        </router-link>
        <router-link to="/signup" class="ml-8">
          <el-button type="primary">{{ $t('navbar.signup') }}</el-button>
        </router-link>
      </div>
      <div v-if="isLoginOpenApi">
        <el-dropdown>
          <span class="el-dropdown-link font-16 font-w-semi-bold">
            {{ accountName }}
            <el-button size="small" style="width: 20px;">
              <el-icon>
                <CaretBottom />
              </el-icon>
            </el-button>
          </span>
          <template #dropdown>
            <el-dropdown-menu class="font-w-semi-bold" style="width: 180px;">
              <el-dropdown-item @click="logout">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </el-header>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { CaretBottom } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({})
const store = useStore()
const router = useRouter()
const menus = [
  {
    name: t('navbar.documentation'),
    path: '/documentation/introduction'
  },
  {
    name: t('navbar.console'),
    path: '/console/app-list'
  }
]
const isLoginOpenApi = computed(() => store.getters['app/isLoggedin'])
const accountName = computed(() => 'Hi, ' + store.getters['app/account'])
const switchLang = computed(() => {
  if (store.getters['app/lang'] === 'id') {
    return 'Indonesia'
  } else {
    return 'English'
  }
})
const isFlag = computed(() => {
  if (store.getters['app/lang'] === 'id') {
    return '/img/icons/id.svg'
  } else {
    return '/img/icons/en.svg'
  }
})

if (isLoginOpenApi.value) {
  store.dispatch('app/getAccountInfo')
}

const handleSwitchLanguage = (lang) => {
  useI18n.locale = lang
  store.dispatch('app/toggleLang', lang)
  router.go()
}
const logout = () => {
  store.dispatch('app/logOut').then(() => {
    router.push({
      path: '/login'
    })
  }).catch((error) => {
    ElMessage({
      type: 'error',
      message: error.message
    })
  })
}
</script>
